module.exports = __webpack_public_path__ + "static/Affordable-0d3e509ce41ec3ce4242181990f92ca2.png";